import axios from "axios";
import { Auth } from 'aws-amplify';

require('dotenv').config();

////console.log (process.env.REACT_APP_API_URL);

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  'Access-Control-Allow-Headers': 'https://jobvious.app',
  'Access-Control-Allow-Origin': 'https://jobvious.app' }
});

instance.interceptors.response.use(null, error => {
  // Errors are passed through to calling code for handling
  // No global toast — let each feature decide how to display errors
  return Promise.reject(error);
});

instance.interceptors.request.use(async config =>
  {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.signInUserSession.accessToken.jwtToken;

  config.headers.Authorization = token;

  return config;

}, (error) => {
  //console.log("This is the error code :", error.response.status);

  return Promise.reject(error);
});

// Generate a UUID for idempotency-keyed mutations.
// Same key on retry → server dedupes; new key per distinct user action.
export const generateIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  // Fallback for older browsers
  return 'idem-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 11);
};

// Attach an Idempotency-Key header if the caller passed one in config.
const withIdempotency = (config = {}) => {
  if (!config.idempotencyKey) return config;
  const { idempotencyKey, ...rest } = config;
  return {
    ...rest,
    headers: { ...(rest.headers || {}), 'Idempotency-Key': idempotencyKey }
  };
};

export class HTTPService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {}

  get (url, parameters = {}, config = {}) {
    if (parameters) {
      return instance.get(url, {params: parameters, ...config})
    } else {
      return instance.get(url, config)
    }
  }

  post (url, payload, config = {}) {
    return instance.post(url, payload, withIdempotency(config))
  }

  put (url, payload, config = {}) {
    return instance.put(url, payload, withIdempotency(config))
  }

  patch (url, payload, config = {}) {
    return instance.patch(url, payload, withIdempotency(config))
  }

  delete (url, config = {}) {
    return instance.delete(url, config)
  }
};
